// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1i-02","productName":"Table_productName__3v4Yp"};